<template>
  <div class="moduleStyle minHeight">
    <div class="market-price-tabs">
      <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <el-tab-pane label="已添加行情价" name="added">
        <basicList
          :config="basicListconfig"
          @search="searchEvent"
          @sortChange="sortChange"
        >
      <template v-slot:customSearch>
        <treeselect
          :options="listClassOptions"
          :multiple="false"
          :clearable="true"
          placeholder="全部类别"
          v-model="basicListconfig.searchParameters.class_id"
          noChildrenText="无子分类"
          style="width:140px;display:inline-block;vertical-align:middle"
        />
      </template>
      <template v-slot:price_market="row">
        <el-input-number
          v-model="row.row.price_market"
          :precision="2"
          :step="0.01"
          :min="0"
          controls-position="right"
          size="small"
          @change="savePrice(row.row)"
        />
      </template>

      <template v-slot:is_smoke="row">
        <el-tag v-if="row.row.is_smoke == 1" type="warning" size="small">烟</el-tag>
        <span v-else>-</span>
      </template>

      <template v-slot:operation="row">
        <el-button type="text" size="small" style="color: #f56c6c" @click="handleDel(row.row)">删除</el-button>
      </template>
    </basicList>
      </el-tab-pane>

      <el-tab-pane label="未添加行情价" name="unadded">
        <basicList
          :config="unaddedConfig"
          @search="searchUnadded"
          @sortChange="sortUnadded"
        >
          <template v-slot:customSearch>
        <treeselect
          :options="listClassOptions"
          :multiple="false"
          :clearable="true"
          placeholder="全部类别"
          v-model="unaddedConfig.searchParameters.class_id"
          noChildrenText="无子分类"
          style="width:140px;display:inline-block;vertical-align:middle"
        />
          </template>
          <template v-slot:price_market="row">
            <el-input-number
              v-model="row.row.price_market"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              style="width:110px"
            />
          </template>
          <template v-slot:action="row">
            <div style="display:flex;align-items:center;gap:4px">
              <el-button type="primary" size="mini" @click.stop="fillLastPurchasePrice(row.row)">上次采购价</el-button>
              <el-button type="primary" size="mini" @click.stop="addMarketInline(row.row)">保存</el-button>
            </div>
          </template>
        </basicList>
      </el-tab-pane>
    </el-tabs>
    </div>

  </div>
</template>

<script>
import { marketPriceGetList, marketPriceAdd, marketPriceSave, marketPriceUp, marketPriceDel, marketPriceGetExistingItemIds, marketPriceGetUnadded, marketPriceGetLastPurchasePrice } from "@/api/marketPrice";
import { stockItemGetlist } from "@/api/product";
import { itemClassGetList } from "@/api/basicConfiguration";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const defaultParams = { page: 1, limit: 10, class_id: null, status: 0 };

export default {
  name: "marketPrice",
  components: { Treeselect },
  data() {
    return {
      activeTab: 'added',
      unaddedConfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "商品搜索",
            type: "input",
            key: "search",
            value: "",
            placeholder: "请输入商品名称/编码"
          },
          {
            label: "商品状态",
            type: "select",
            key: "status",
            filterable: false,
            options: [
              { label: "上架", value: 0 },
              { label: "下架", value: 1 }
            ],
            value: 0
          }
        ],
        data: [],
        column: [
          { label: "ID", prop: "item_id", width: 80 },
          { label: "商品名称", prop: "name", minWidth: 160 },
          { label: "商品编码", prop: "item_number", width: 140 },
          { label: "成本价", prop: "avg_price", width: 120 },
          { label: "行情价(条/箱)", prop: "price_market", slot: true, width: 140 },
          { label: "操作", prop: "action", slot: true, width: 190 },
        ],
        isPage: true,
        total: 0,
        searchParameters: { page: 1, limit: 10, class_id: null, status: 0 },
      },
      basicListconfig: {
        loading: false,

        search: [
          {
            label: "商品搜索",
            type: "input",
            key: "search",
            value: "",
            placeholder: "请输入商品名称/编码"
          },
          {
            label: "是否烟",
            type: "select",
            key: "is_smoke",
            options: [
              { label: "全部", value: "" },
              { label: "是", value: 1 },
              { label: "否", value: 0 }
            ]
          },
          {
            label: "商品状态",
            type: "select",
            key: "status",
            filterable: false,
            options: [
              { label: "上架", value: 0 },
              { label: "下架", value: 1 }
            ],
            value: 0
          }
        ],
        data: [],
        column: [
          { label: "ID", prop: "item_id", width: 80 },
          { label: "商品名称", prop: "item_name", minWidth: 160 },
          { label: "商品编码", prop: "item_number", width: 140 },
          { label: "行情价(条/箱)", prop: "price_market", slot: true, width: 190, sortable: true },
          { label: "成本价", prop: "avg_price", width: 120 },
          { label: "是否烟", prop: "is_smoke", slot: true, width: 100 },
          { label: "更新时间", prop: "update_time", width: 160, sortable: true },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParams),
      },
      listClassOptions: [],
      addDialog: {
        visible: false,
        item_id: "",
        price_market: 0,
        class_id: "",
        keyword: "",
        itemOptions: [],
        classOptions: [],
        searchLoading: false,
        loading: false,
      },
      existingItemIds: [], // 已有行情价的商品ID
    };
  },
  created() {
    this.getlist();
    this.loadListClasses();
  },

  methods: {
    onTabChange(tab) {
      if (tab.name === 'unadded' && !this.unaddedConfig.data.length) {
        this.getUnadded();
      }
    },

    getUnadded() {
      this.unaddedConfig.loading = true;
      marketPriceGetUnadded(this.unaddedConfig.searchParameters).then((res) => {
        this.unaddedConfig.loading = false;
        if (res.code == 1) {
          this.unaddedConfig.data = res.data.map(item => ({
            ...item,
            is_smoke: item.is_smoke == 1 ? '是' : '否',
          }));
          this.unaddedConfig.total = res.count;
        }
      }).catch(() => {
        this.unaddedConfig.loading = false;
      });
    },

    searchUnadded(data, page, pageSize) {
      if (page || pageSize) {
        if (pageSize) this.unaddedConfig.searchParameters.limit = pageSize;
      } else if (data) {
        for (const key in data) {
          this.unaddedConfig.searchParameters[key] = data[key];
        }
        this.unaddedConfig.searchParameters.page = 1;
      }
      this.getUnadded();
    },

    sortUnadded(data) {
      this.unaddedConfig.searchParameters.page = 1;
      this.unaddedConfig.searchParameters.order_column = data.prop;
      this.unaddedConfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getUnadded();
    },

    addMarketInline(row) {
      if (!row.price_market || Number(row.price_market) <= 0) {
        this.$message.warning('请输入行情价');
        return;
      }
      marketPriceSave({
        item_id: row.item_id,
        price_market: row.price_market,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success('保存成功');
          this.getUnadded();
          this.loadExistingItemIds();
          // 顺便刷新已有列表
          this.getlist();
        } else {
          this.$message.error(res.msg || '保存失败');
        }
      });
    },

    fillLastPurchasePrice(row) {
      marketPriceGetLastPurchasePrice({ item_id: row.item_id }).then((res) => {
        if (res.code === 1 && res.data) {
          if (!res.data.has_history) {
            this.$message.warning('暂无采购历史');
            return;
          }
          row.price_market = res.data.price;
          this.$message.success('已填入上次采购价');
        } else {
          this.$message.error(res.msg || '获取失败');
        }
      }).catch(() => {
        this.$message.error('获取失败');
      });
    },

    loadExistingItemIds() {
      marketPriceGetExistingItemIds().then((res) => {
        if (res.code == 1) {
          this.existingItemIds = (res.data || []).map(Number);
        }
      });
    },

    getlist() {
      this.basicListconfig.loading = true;
      marketPriceGetList(this.basicListconfig.searchParameters).then((res) => {
        this.basicListconfig.loading = false;
        if (res.code == 1) {
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.$message.error(res.msg || "获取列表失败");
        }
      }).catch(() => {
        this.basicListconfig.loading = false;
      });
    },

    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
      }
      this.getlist();
    },

    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },

    showAddDialog() {
      const lastPrice = this.addDialog.price_market || 0;
      this.addDialog = {
        visible: true,
        item_id: "",
        price_market: lastPrice,
        class_pid: "",
        keyword: "",
        itemOptions: [],
        classOptions: this.addDialog.classOptions,
        searchLoading: false,
        loading: false,
      };
      // 加载类别列表（仅首次）
      if (!this.addDialog.classOptions.length) {
        this.loadClasses();
      }
    },

    loadListClasses() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.listClassOptions = this.$findChildren(0, res.data);
        }
      });
    },

    loadClasses() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.addDialog.classOptions = this.$findChildren(0, res.data);
          if (!this.listClassOptions.length) {
            this.listClassOptions = this.addDialog.classOptions;
          }
        }
      });
    },

    remoteSearchItem(query) {
      this.addDialog.keyword = query || "";
      if (!query && !this.addDialog.class_id) {
        this.addDialog.itemOptions = [];
        return;
      }
      this.addDialog.searchLoading = true;
      const params = {
        comp_id: 100,
        limit: 200,
        status: 1,
      };
      if (query) {
        params.keywords = query;
      }
      if (this.addDialog.class_id) {
        params.class_id = this.addDialog.class_id;
      }
      stockItemGetlist(params).then((res) => {
        this.addDialog.searchLoading = false;
        if (res.code == 1) {
          // 过滤掉已有行情价的商品
          this.addDialog.itemOptions = res.data
            .filter((item) => !this.existingItemIds.includes(Number(item.item_id)))
            .map((item) => ({
              label: item.name + "(" + item.item_number + ")",
              value: item.item_id,
            }));
        }
      }).catch(() => {
        this.addDialog.searchLoading = false;
      });
    },

    handleAdd() {
      if (!this.addDialog.item_id) {
        this.$message.error("请选择商品");
        return;
      }
      const item = this.addDialog.itemOptions.find((o) => o.value === this.addDialog.item_id);
      const name = item ? item.label : "该商品";
      this.$confirm(`确定要为【${name}】添加行情价 ¥${this.addDialog.price_market} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.addDialog.loading = true;
        marketPriceSave({
          item_id: this.addDialog.item_id,
          price_market: this.addDialog.price_market,
        }).then((res) => {
          this.addDialog.loading = false;
          if (res.code == 1) {
            this.$message.success("添加成功");
            this.addDialog.visible = false;
            this.loadExistingItemIds();
            this.getlist();
          } else {
            this.$message.error(res.msg || "添加失败");
          }
        }).catch(() => {
          this.addDialog.loading = false;
        });
      }).catch(() => {});
    },

    savePrice(row) {
      this.$confirm(`确定将【${row.item_name}】行情价修改为 ¥${row.price_market} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        marketPriceUp({
          id: row.id,
          price_market: row.price_market,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg || "保存失败");
            this.getlist();
          }
        });
      }).catch(() => {
        this.getlist();
      });
    },

    handleDel(row) {
      this.$confirm("确定删除该行情价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        marketPriceDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.loadExistingItemIds();
            this.getlist();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      }).catch(() => {});
    },
  },
};
</script>
<style scoped>
.market-price-tabs {
  background: #fff;
  margin-bottom: 12px;
}
.market-price-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}
.market-price-tabs >>> .el-tabs__nav-wrap::after {
  background-color: #ebeef5;
}
.market-price-tabs >>> .el-tabs__item {
  padding: 0 12px !important;
  font-size: 13px;
  height: 36px;
  line-height: 36px;
}
.market-price-tabs >>> .el-tabs__active-bar {
  background-color: #409eff;
}
.smoke-tip {
  color: #909399;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketPrice/index.vue